export function ServicesPage() {
  return (
    <section className="services-page">
      <header className="section-header">
        <h2>Services</h2>
        <p>Perhaps we could exchange currency for the modification of the universe as you need. Such potential collaborations could include, but are not limited to things like:</p>
      </header>
      <ul className="feature-list">
        <li>website development and custom domain setup</li>
        <li>engineering support</li>
        <li>troubleshooting hardware and software</li>
        <li>ai-enabled augmentation to become a sovereign economic agent</li>
      </ul>
      <p className="text-subtle">Additional interest and inquiries can be made via means on the <a href="/contact">contact</a> page.</p>
    </section>
  );
}
